
















































































































































































































import BaseFormEdit from '../../models/base.form.edit';
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import Editor from './Editor.vue';

@Component({ components: { Editor }})
export default class Edit extends BaseFormEdit {
  form = { subject: '', message: '' } as any;

  get isGskFormTemplate(){
    return this.form.type == 3;
  }

  get isDonorsTemplate(){
    return this.form.type == 5;
  }

  get isPatientBill(){
    return this.form.type == 6;
  }
}
